<template>
  <div class="arrival-banner">
    <div class="unapplied" v-if="!userArrivalTimeSlot && !configuration.areArrivalTimeSlotsLocked">
      <h2 class="subtitle">Prijavi svoj dolazak</h2>
      <p class="description">
        Za dolazak na konferenciju potrebna je prijava. Odaberi svoj termin kako bismo se pobrinuli da se poštuju sve
        epidemiološke mjere.
      </p>
      <button class="button-open" @click="open">Odabir termina</button>
    </div>
    <div class="applied" v-if="userArrivalTimeSlot">
      <h2 class="subtitle">Tvoj dolazak</h2>
      <p class="description" v-if="!configuration.areArrivalTimeSlotsLocked">
        Tvoj termin je: {{ formattedTimeSlot }} Vidimo se na FESB-u. Za promijeniti termin, morate prvo otkazati
        trenutni. Termin možeš mijenjati do 12.05. u 23:59
        <br />
        <span @click="openCancelModal" class="blue">Otkaži termin</span>
      </p>
      <p class="description" v-else>
        Tvoj termin je: {{ formattedTimeSlot }} Vidimo se na FESB-u.
        <br />
        Izmjena termina u ovom trenutku više nije moguća.
      </p>
      <ConfirmationModal
        v-if="isCancelModalVisible"
        @close="closeCancelModal"
        @onConfirm="cancelArrival"
        title="Jeste li sigurni?"
      />
    </div>
    <ArrivalTimePickerModal
      v-if="isModalVisible"
      @closeArrivalModal="close"
      @saveArrivalModal="getUserArrivalTimeSlot"
    />
  </div>
</template>

<script>
import moment from 'moment';

import ArrivalTimePickerModal from './ArrivalTimePickerModal.vue';
import ConfirmationModal from '../ConfirmationModal.vue';

export default {
  components: { ArrivalTimePickerModal, ConfirmationModal },
  name: 'ArrivalBanner',
  props: {
    configuration: {},
  },
  data() {
    return {
      isModalVisible: false,
      userArrivalTimeSlot: null,
      isCancelModalVisible: false,
    };
  },
  mounted() {
    this.getUserArrivalTimeSlot();
  },
  methods: {
    open() {
      this.isModalVisible = true;
      document.body.classList.add('no-scroll');
    },
    close() {
      this.isModalVisible = false;
      document.body.classList.remove('no-scroll');
    },
    openCancelModal() {
      this.isCancelModalVisible = true;
    },
    closeCancelModal() {
      this.isCancelModalVisible = false;
    },
    getUserArrivalTimeSlot() {
      this.$axios.get(`${this.$API_URL}/user/arrival-time-slot`).then(response => {
        this.userArrivalTimeSlot = response.data;
        this.isModalVisible = false;
        this.isCancelModalVisible = false;
      });
    },
    cancelArrival() {
      this.$axios.post(`${this.$API_URL}/user/cancel-arrival`).then(() => {
        this.getUserArrivalTimeSlot();
      });
    },
  },
  computed: {
    formattedTimeSlot() {
      if (!this.userArrivalTimeSlot) {
        return '';
      }

      moment.locale('hr');

      return `${moment(this.userArrivalTimeSlot.startOfTimeSlot).format('dddd DD.MM.')} - ${moment(
        this.userArrivalTimeSlot.startOfTimeSlot,
      ).format('HH:mm')}-${moment(this.userArrivalTimeSlot.endOfTimeSlot).format('HH:mm')}`;
    },
  },
};
</script>

<style scoped>
.subtitle {
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 36px;
  color: #ffffff;
  margin-top: 0;
  margin-bottom: 8px;
}

.description {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 0;
  margin-bottom: 16px;
  max-width: 400px;
}

.button-open {
  border: none;
  background: #30cec2;
  border-radius: 15px;
  padding: 12px 32px;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
  margin-bottom: 56px;
  cursor: pointer;
}

.blue {
  color: #30cec2;
  cursor: pointer;
}

@media screen and (min-width: 1024px) {
  .description {
    margin-bottom: 24px;
  }
}
</style>
